import * as Sentry from "@sentry/react";
const SENTRY_DSN = process.env.SENTRY_DSN;
const SENTRY_TRACES_SAMPLE_RATE = process.env.SENTRY_TRACES_SAMPLE_RATE;
if (SENTRY_DSN) {
    Sentry.init({
        dsn: SENTRY_DSN,
        integrations: [
            Sentry.browserTracingIntegration(),
            Sentry.replayIntegration(),
        ],
        tracesSampleRate: SENTRY_TRACES_SAMPLE_RATE
            ? parseFloat(SENTRY_TRACES_SAMPLE_RATE)
            : 0.1,
        // URLs that enable trace propagation
        tracePropagationTargets: ["localhost", /^https:\/\/api\.tenkay\.ai\/api/],
        // Capture 5% of sessions
        replaysSessionSampleRate: 0.05,
        // Capture 100% of sessions with an error
        replaysOnErrorSampleRate: 1.0,
    });
}
const SentryLoggingLevels = {
    log: "log",
    info: "info",
    debug: "debug",
    warning: "warning",
    error: "error",
    fatal: "fatal",
};
export function captureErrorWithContext(error, context) {
    Sentry.captureException(error, {
        level: context?.level ?? SentryLoggingLevels.error,
        tags: context?.tags ?? {},
        extra: context?.extra ?? {},
    });
}
